export default {
    namespaced: true,
    state: {
        isHiddenMenu: sessionStorage.getItem('isHiddenMenu'),
        sourcePath: sessionStorage.getItem('iframeSourcePath'),
        source: sessionStorage.getItem('iframeSource'),
        isNoLogin: sessionStorage.getItem('iframeIsNoLogin'),
    },
    getters: {
        isHiddenMenu: (state) => state.isHiddenMenu,
        sourcePath: (state) => state.iframeSourcePath, // 内嵌网页时进来的源路径，一般用于切换企业后继续重定向到这个页面
        isWmsSystem: (state) => state.source === 'WMS', // 系统来源于WMS
        isNoLogin: (state) => state.isNoLogin === 'true', // 内嵌来源系统不走登录
        onlyGpsPage: (state) => state.source === 'onlyGpsPage' // 系统来源于通用的仅需要轨迹内嵌的系统
    },
    mutations: {
        SET_IS_HIDDEN_MENU: (state, type) => {
            state.isHiddenMenu = type
            sessionStorage.setItem('isHiddenMenu', type)
        },
        SET_SOURCE_PATH: (state, path) => {
            state.sourcePath = path
            sessionStorage.setItem('iframeSourcePath', path)
        },
        SET_SOURCE: (state, source) => {
            state.source = source
            sessionStorage.setItem('iframeSource', source)
        },
        SET_IS_NO_LOGIN: (state, isNoLogin) => {
            state.isNoLogin = isNoLogin
            sessionStorage.setItem('iframeIsNoLogin', isNoLogin)
        },
    }
}
